export var dataHooks = {
  radioButtonItem: 'radio-button-item',
  tab: 'tab'
};